import React from 'react';

const AaSymbol = ({ isDarkTheme }) => {
  const fillColor = isDarkTheme ? '#fff' : '#000';

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 19 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59 2.14 2.19 12H.13L4.41.62h1.32l-.14 1.52ZM8.43 12l-3.4-9.86L4.86.62H6.2L10.5 12H8.42Zm-.16-4.22v1.56h-6.2V7.78h6.2Zm8.07 2.52V6.27c0-.3-.05-.56-.16-.78-.11-.22-.28-.39-.5-.5-.22-.13-.5-.19-.83-.19-.3 0-.57.06-.8.16-.22.1-.4.25-.52.42-.12.18-.19.38-.19.6h-1.87c0-.33.08-.65.24-.96.16-.32.4-.6.7-.84.31-.25.68-.44 1.1-.58.43-.14.91-.2 1.44-.2.64 0 1.2.1 1.7.31.49.21.87.54 1.15.97.3.43.43.96.43 1.6v3.77c0 .38.03.73.08 1.04.06.3.14.56.24.79V12h-1.93c-.08-.2-.15-.46-.2-.77a6.31 6.31 0 0 1-.08-.93Zm.28-3.44.01 1.16h-1.35c-.35 0-.65.04-.92.1a1.9 1.9 0 0 0-.66.29 1.22 1.22 0 0 0-.54 1.05c0 .22.06.43.16.62.1.18.26.32.45.43.2.1.45.15.74.15a2.07 2.07 0 0 0 1.7-.82c.16-.23.25-.45.26-.66l.6.84a3.33 3.33 0 0 1-.91 1.4 2.95 2.95 0 0 1-2.02.74c-.55 0-1.04-.11-1.48-.33a2.63 2.63 0 0 1-1.01-.9 2.7 2.7 0 0 1-.12-2.48c.17-.35.42-.64.75-.87.33-.24.74-.41 1.22-.53a6.52 6.52 0 0 1 1.64-.2h1.48Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default AaSymbol;
